import { Program } from '@type/buzzkuri/programs-categor'
import React from 'react'
import { PopularProgramCard } from './Card'

type Props = {
  popularPrograms: Program[]
  slug?: string
}

export const PopularProgramCardGroup = ({
  popularPrograms,
  slug
}: Props): JSX.Element => (
  <>
    {popularPrograms.map((program, i) => (
      <div key={i} className="mb-[13.9vw] last:mb-0 lg:mb-[4.8vw]">
        <PopularProgramCard {...program} slug={slug} idx={i + 1} />
      </div>
    ))}
  </>
)
